// hooks
import usePagination from '@/hooks/usePagination';
// types
import { OrderEnum, OrgRoleTypeEnum } from '@/types/schema';

import { useOrgRolesNQuery } from '../../graphql/queries/generated/orgRolesN';

interface UseRolesParams {
  searchText?: string;
  departmentId?: string;
  ids?: string[];
  first?: number;
  pause?: boolean;
  type?: OrgRoleTypeEnum[];
}

const useRoles = ({
  departmentId,
  searchText,
  ids,
  type,
  first,
  pause = false,
}: UseRolesParams) => {
  const {
    isFetching,
    isFetchingMore,
    error,
    data,
    fetchMore,
    isLoading,
    totalCount = 0,
  } = usePagination(
    useOrgRolesNQuery,
    {
      filters: { departmentId, name: searchText, ids, type },
      sort: [{ order: OrderEnum.Asc, field: 'name' }],
      first,
    },
    { edgeKey: 'orgRoles', pause },
  );

  return {
    error,
    fetchMore,
    totalCount,
    roles: data,
    isFetching,
    isFetchingMore,
    isLoading,
  };
};

export default useRoles;
